// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"3ea816ad","417":"754442b6","616":"c1d4e9bd","634":"aeed368c","937":"394b863c"}[chunkId] + ".chunk.css";
};